module.exports = __webpack_public_path__ + "static/thumbnail-d9ac46c9a2fb81374cd9ab436d516f5c.png";